/* Inline ghost-text autocomplete for the header pill search input.
   Pulls suggestions from the top-level navigation links (the same words
   merchants curate in the main menu) so the completion always reflects
   real catalogue categories. Tab / ArrowRight at end-of-input accepts
   the suggestion; Escape clears it. */
(function () {
  function init() {
    var pill = document.querySelector('.header__search-bar');
    if (!pill) return;
    var input = pill.querySelector('input[name="q"]');
    var ghost = pill.querySelector('.predictive-search__ghost');
    if (!input || !ghost) return;

    var suggestions = collectSuggestions();
    var suggestion = '';

    function collectSuggestions() {
      var items = document.querySelectorAll(
        '.header__bottom-navigation .header__linklist-item[data-item-title]'
      );
      var seen = {};
      var list = [];
      for (var i = 0; i < items.length; i++) {
        var link = items[i].querySelector('a.header__linklist-link[href]');
        if (link) {
          try {
            var path = new URL(link.getAttribute('href') || '', window.location.origin).pathname;
            if (!/^\/collections\/[^/]+/.test(path)) continue;
          } catch (e) {
            continue;
          }
        }
        var text = (items[i].getAttribute('data-item-title') || '').trim();
        if (!text || text.toLowerCase() === 'collections' || seen[text.toLowerCase()]) continue;
        seen[text.toLowerCase()] = true;
        list.push(text);
      }
      return list;
    }

    function escapeHtml(s) {
      return s.replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function clearGhost() {
      suggestion = '';
      ghost.textContent = '';
    }

    function renderGhost(value) {
      if (!suggestion) { ghost.textContent = ''; return; }
      ghost.innerHTML =
        '<span class="predictive-search__ghost-typed">' + escapeHtml(value) + '</span>' +
        '<span class="predictive-search__ghost-rest">' + escapeHtml(suggestion.slice(value.length)) + '</span>';
    }

    // Find a completion for `value`: any suggestion whose full text prefix-matches.
    // Falls back to per-word match (so typing "leha" inside "Half Saree Lehengas"
    // can still hint "Lehengas").
    function findCompletion(value) {
      var v = value.toLowerCase();
      var wordMatch = '';
      for (var i = 0; i < suggestions.length; i++) {
        var text = suggestions[i];
        if (text.length > value.length && text.toLowerCase().indexOf(v) === 0) return text;
        if (!wordMatch) {
          var words = text.split(/\s+/);
          for (var k = 0; k < words.length; k++) {
            var w = words[k];
            if (w.length > value.length && w.toLowerCase().indexOf(v) === 0) { wordMatch = w; break; }
          }
        }
      }
      return wordMatch;
    }

    input.addEventListener('input', function () {
      var value = input.value;
      if (!value) { clearGhost(); return; }
      var match = findCompletion(value);
      if (match) {
        suggestion = match;
        renderGhost(value);
      } else {
        clearGhost();
      }
    });

    input.addEventListener('keydown', function (e) {
      if (!suggestion) return;
      var atEnd = input.selectionStart === input.value.length && input.selectionEnd === input.value.length;
      if (e.key === 'Tab' || (e.key === 'ArrowRight' && atEnd)) {
        e.preventDefault();
        input.value = suggestion;
        clearGhost();
        input.dispatchEvent(new Event('input', { bubbles: true }));
      } else if (e.key === 'Escape') {
        clearGhost();
      }
    });

    // Inline clear-X — wipes the typed value and re-fires `input` so the ghost
    // resets to its empty state.
    pill.addEventListener('click', function (e) {
      var clear = e.target.closest && e.target.closest('[data-action="clear-input"]');
      if (!clear) return;
      e.preventDefault();
      input.value = '';
      clearGhost();
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
